export const HEADER_3_CONSTANTS = {
  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "promotional_text",
      label: "Promotional Text",
      value: "Admissions are closing on 31st Jan. Avail up to 25% scholarship (valid only for this batch)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter promotional text",
      required: false,
      defaultValue: "Admissions are closing on 31st Jan. Avail up to 25% scholarship (valid only for this batch)",
    },
    {
      fieldName: "promotional_text_color",
      label: "Promotional Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter promotional text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "auto_scroll_speed",
      label: "Auto Scroll Speed (milliseconds)",
      value: "20000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Duration for one scroll cycle in ms (e.g. 20000 for 20s)",
      required: false,
      defaultValue: "20000",
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1 (Left)",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2 (Right)",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "phone_icon",
      label: "Phone Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Phone Icon (optional - default call icon will be used)",
    },
    {
      fieldName: "phone_icon_alt",
      label: "Phone Icon Alt Text",
      value: "Phone",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for phone icon",
    },
    {
      fieldName: "phone_number",
      label: "Phone Number",
      value: "+91 7973615772",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter phone number",
    },
    {
      fieldName: "phone_number_text_color",
      label: "Phone Number Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter phone number text color",
    },
    {
      fieldName: "button_name",
      label: "Button Name",
      value: "WhatsApp Chat",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text (e.g., WhatsApp Chat)",
    },
    {
      fieldName: "button_link",
      label: "Button Link",
      value: "#whatsapp",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button link URL or WhatsApp link",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon (optional - default WhatsApp icon will be used)",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "WhatsApp",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#4CAF51",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button color (WhatsApp green: #4CAF51)",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Toggle status",
      required: false,
      defaultValue: true,
    },
  ],
};
